import pt_messages from './pt.json';
import en_messages from './en.json';

export default {
  'pt-BR': pt_messages,
  'en-US': en_messages,
};
